/** @jsxImportSource @emotion/react */
import { TableRow } from "../../../components/table-components/TableRow";
import { TableCellLink } from "../../../components/table-components/TableCellLink";
import { routes } from "../../../appRoutingHelpers";
import * as authSelectors from "../../auth/authSelectors";
import { StyledText } from "../../../assets/typography/typography";
import { colors } from "../../../components/colors";
import { Menu } from "../models/Menus";
import { css } from "@emotion/react";
import { MenuDropdown } from "./MenuDropdown";
import { PublishedRestaurantsPopover } from "./PublishedRestaurantsPopover";
import ReactTimeAgo from "react-time-ago";
import { SmallBadge } from "../../../components/SmallBadge";
import { PublishAndPushMenuSelector } from "./PublishAndPushMenuSelector";
import { useSelector } from "react-redux";
import { getCountryInfo } from "../../../service/countries-service";

type Props = {
  menu: Menu;
};

const ellipsisWrapperStyle = css`
  display: flex;
  flex-direction: row;
  justify-content: end;
  width: fit-content;
`;

const menuNameStyle = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  text-decoration: none !important;
`;

const dropdownWrapperStyle = css`
  display: flex;
  align-items: end;
  flex-direction: row;
  gap: 8px;
  justify-content: end;
`;

export const MenuListTableRow = ({ menu }: Props) => {
  const organizationKeyName = useSelector(
    authSelectors.selectedOrganizationKeyName
  );

  const href = routes.menuEdit(organizationKeyName, menu.id);
  const countryData = getCountryInfo(menu.countryAlpha2Code);

  return (
    <>
      <TableRow>
        <TableCellLink href={href} className="pl-5">
          <div css={menuNameStyle}>
            <StyledText
              className="bodyTextRegular mb-0"
              color={colors.textPrimary}
            >
              {menu.name}
            </StyledText>
            {menu.haveChanges && (
              <SmallBadge>
                <StyledText
                  className="bodySubtextRegular mb-0"
                  color={colors.textPrimary}
                >
                  Unpushed edits
                </StyledText>
              </SmallBadge>
            )}
          </div>
        </TableCellLink>
        <TableCellLink href={href}>
          <StyledText
            className="bodyTextRegular mb-0"
            color={colors.textPrimary}
          >
            {countryData.name} {countryData.emojiFlag}
          </StyledText>
        </TableCellLink>
        <TableCellLink href={href}>
          <PublishedRestaurantsPopover
            restaurantCount={menu.salesChannelsCount}
            id={menu.id!}
          />
        </TableCellLink>
        <TableCellLink href={href}>
          {menu.publishedAt ? (
            <StyledText
              className="bodyTextRegular mb-0"
              color={colors.textPrimary}
            >
              <ReactTimeAgo date={new Date(menu.publishedAt)} />
            </StyledText>
          ) : (
            <StyledText
              className="bodyTextRegular mb-0"
              color={colors.textPrimary}
            >
              -
            </StyledText>
          )}
        </TableCellLink>
        <td css={dropdownWrapperStyle}>
          {menu.haveChanges && <PublishAndPushMenuSelector menuId={menu.id} />}
          <div css={ellipsisWrapperStyle}>
            <MenuDropdown menuItem={menu} editLink={href} />
          </div>
        </td>
      </TableRow>
    </>
  );
};
